import { Outlet } from "react-router-dom";

const SearchOutlet = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default SearchOutlet;
